<div class="operators-page">
  <div class="setting-page">
    <legend>Operators</legend>

    <div class="header">
      <div class="search-container">
        <arm-search (onSearch)="onSearch($event)"
                    [searchComponent]="operatorsSearchComponent"
                    [searchData]="searchData"
                    [searchTerms]="searchTerms">
        </arm-search>
      </div>

      <div class="action-buttons">
        <arm-action-bar (addClick)="addItem()" [disableAdd]="!isSecurityAdmin"
                        (deleteClick)="removeItem()" [disableDelete]="!selection || !isSecurityAdmin"
                        (refreshClick)="refresh()"
                        (editClick)="editItem()" [disableEdit]="!selection || isUnauthorized"></arm-action-bar>
      </div>
    </div>

    <div class="credentials-table">
      <arm-table [displayedColumns]="displayedColumns"
                 (onSelection)="onSelection($event)" [data]="items"
                 [isMultipleSelection]="false"
                 [isClientSide]="true"></arm-table>
    </div>
  </div>
</div>
